export default __webpack_public_path__ + "static/favicon-32x32.png";